var map = {
	"./WMZ.png": "1567",
	"./advcash.png": "fd3a",
	"./alfabank.png": "0329",
	"./alipay.png": "56cc",
	"./alipay_hk.png": "d328",
	"./another.png": "6ff1",
	"./antilopay.png": "f9d0",
	"./antilopay_card.png": "35f3",
	"./antilopay_sbp.png": "9de3",
	"./applePay.png": "6ae9",
	"./beeline.png": "ce82",
	"./bitcoin-min.png": "975b",
	"./bitcoin.png": "656e",
	"./boleto.png": "55af",
	"./card.png": "2abd",
	"./card_1.svg": "9f7f",
	"./card_2.svg": "6bc8",
	"./card_3.svg": "d133",
	"./card_3_belarus.svg": "8d40",
	"./card_4.svg": "86f6",
	"./card_4_kzt.svg": "bc8c",
	"./card_gm.png": "3ea8",
	"./card_gm_ru.png": "a659",
	"./card_gm_ua.png": "e45e",
	"./card_payok.png": "7e91",
	"./cards-kz.png": "6c82",
	"./cards-ua.png": "e2f6",
	"./cards.png": "a02f",
	"./dana.png": "7049",
	"./direct_banking_europe.png": "a03f",
	"./ecopayz.png": "0607",
	"./enot.png": "ce89",
	"./ethereum.png": "f01a",
	"./free-kassa.png": "aa46",
	"./gm.png": "d67b",
	"./gm_cards.png": "8808",
	"./googlePay.png": "7223",
	"./google_cash.png": "deea",
	"./gram.png": "6cc5",
	"./gramPaySystem.png": "5d53",
	"./indonesia_bank.png": "1ee4",
	"./indonesia_bank_transfer.png": "1f1d",
	"./kassa24.png": "385c",
	"./lava.png": "c0a3",
	"./lava_card.png": "6d8f",
	"./litecoin.png": "a35e",
	"./local_card_brazil.png": "3fb7",
	"./malaysia_bank.png": "f97e",
	"./megaphone.png": "03c0",
	"./mexico_bank.png": "13e6",
	"./mobileOperators.png": "db94",
	"./momopay.png": "7b59",
	"./mts.png": "00c0",
	"./new_fk.png": "6643",
	"./online_bank.png": "7e9e",
	"./pagoefectivo.png": "985e",
	"./payeer.png": "db2d",
	"./payok.png": "3c92",
	"./philippines_bank.png": "3eb0",
	"./pix.png": "e1a9",
	"./promptpay.png": "6ab8",
	"./promsviaz.png": "1663",
	"./qiwi.png": "3656",
	"./redpagos.png": "aca6",
	"./rub_card.png": "879b",
	"./sberbank.png": "658c",
	"./sberpay_1.svg": "f787",
	"./sbp_1.svg": "d2b6",
	"./sbp_2.svg": "c444",
	"./sbp_3.svg": "7ea6",
	"./sbp_gm.svg": "e50a",
	"./servipag.png": "66eb",
	"./skinpay.png": "6e25",
	"./tele2.png": "ce2a",
	"./tether.png": "8b4c",
	"./tether_trc20.png": "b1c5",
	"./thailand_bank.png": "a010",
	"./thailand_bank_transfer.png": "42dd",
	"./touch_and_go.png": "11ea",
	"./tron.png": "b9c3",
	"./uah_card.png": "10c1",
	"./vietnam_bank.png": "8ca8",
	"./vietnam_bank_qr.png": "f9aa",
	"./vietnam_bank_transfer.png": "1101",
	"./webmoney.png": "e88d",
	"./webpay.png": "3e5b",
	"./yoomoney.png": "693a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "95dc";